import { ArchiveClockOutlineIcon } from './ArchiveClockOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 0087686D-DB93-46D3-AD96-C8BA2F17E0D6
 * name archive-clock-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-clock-outline.svg
 * tags
 * - Date / Time 
 */
export const BoxTimeOutlineIcon = ArchiveClockOutlineIcon;
export default BoxTimeOutlineIcon